// src/pages/UsersPage.js
import React, { useState, useEffect } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '../firebase';

class UsersPage extends React.Component {
  state = {
    users: [],
    loading: true,
    error: '',
    emailToMakeAdmin: '',
  };

  // We create the function references once
  listUsersCallable = httpsCallable(getFunctions(app, 'asia-southeast1'), 'listUsers');
  setAdminClaimCallable = httpsCallable(getFunctions(app, 'asia-southeast1'), 'setAdminClaim');
  deleteUserCallable = httpsCallable(getFunctions(app, 'asia-southeast1'), 'deleteUser'); // Add this line

  componentDidMount() {
    this.fetchUsers();
  }

  fetchUsers = async () => {
    this.setState({ loading: true, error: '' });
    try {
      const result = await this.listUsersCallable();
      this.setState({ users: result.data.users, loading: false });
    } catch (err) {
      console.error(err);
      this.setState({ error: `Error: ${err.message}`, loading: false });
    }
  };

  handleDeleteUser = async (user) => {
    const confirmMessage = `Are you sure you want to delete this user?\n\nUID: ${user.uid}\nEmail: ${user.email || 'Anonymous'}\n\nThis action cannot be undone.`;

    if (window.confirm(confirmMessage)) {
      try {
        await this.deleteUserCallable({ uid: user.uid });
        alert(`User ${user.uid} deleted successfully.`);
        this.fetchUsers(); // Refresh the user list
      } catch (err) {
        alert(`Error: ${err.message}`);
        console.error(err);
      }
    }
  };

  handleMakeAdmin = async (email) => {
    const trimmedEmail = email.trim();

    if (!trimmedEmail) {
      alert("Please enter an email address.");
      return;
    }

    // --- ADD THIS LINE ---
    console.log("React App is sending this email:", trimmedEmail);

    try {
      const result = await this.setAdminClaimCallable({ email: trimmedEmail });
      alert(result.data.message);
      this.fetchUsers();
    } catch (err) {
      alert(`Error: ${err.message}`);
      console.error(err);
    }
  };

  render() {
    const { users, loading, error, emailToMakeAdmin } = this.state;

    return (
      <div className="page-content">
        <h1>User Management</h1>

        <div className="card" style={{ backgroundColor: '#fff8e1', border: '1px solid #ffecb3' }}>
          <h4>First-Time Admin Setup</h4>
          <p>If you see a 'permission-denied' error below, use this form to make your account an admin.</p>
          <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
            <input
              value={emailToMakeAdmin}
              onChange={e => this.setState({ emailToMakeAdmin: e.target.value })}
              placeholder="Enter your admin email"
            />
            <button className="btn btn-primary" onClick={() => this.handleMakeAdmin(emailToMakeAdmin)}>Set Admin</button>
          </div>
        </div>

        {loading && <p>Loading users...</p>}
        {error && <p className="error-message" style={{ color: 'red' }}>{error}</p>}

        {!loading && !error && (
          <div className="table-container">
            <table className="levels-table">
              <thead>
                <tr>
                  <th>Email / Type</th>
                  <th>Is Admin?</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.map(user => (
                  <tr key={user.uid}>
                    <td>{user.isAnonymous ? <i>Anonymous Guest</i> : user.email}</td>
                    <td>{user.isAdmin ? '✅ Yes' : 'No'}</td>
                    <td>
                      <div className="action-buttons">
                        <button
                          className="btn btn-danger"
                          onClick={() => this.handleDeleteUser(user)}
                        >
                          Delete
                        </button>
                        {!user.isAdmin && (
                          <button className="btn btn-primary" onClick={() => this.handleMakeAdmin(user.email)}>
                            Make Admin
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  }
}

export default UsersPage;